<main>
    <!-- <div class="main-wrapper sign-up" *ngIf="!isNewABmFlow">
      <h1 style="line-height: normal !important;">Device Enrollment Programs: {{prodcode}}</h1>
    </div> -->
    <!--step indicator section starts -->
    <!-- <section [attr.aria-label]="currentStep" class="step-section" *ngIf="!isNewABmFlow">
      <div class="main-wrapper">
        <app-stepindicator [stepIndicators]="stepIndicators"></app-stepindicator>
      </div>
    </section> -->
    <router-outlet></router-outlet>
</main>
  